module.exports = __webpack_public_path__ + "static/img/logo.a39df76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/logo.png
// module id = Phjq
// module chunks = 1